import { apiClient } from './client';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://ayonkdesigns.com/api';

const getHeaders = () => {
    const token = localStorage.getItem('auth_token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const projectsApi = {
    getAll: () => apiClient.get('/projects'),
    getById: (id) => apiClient.get(`/projects/${id}`),
    create: (data) => apiClient.post('/projects', data),
    update: (id, data) => apiClient.put(`/projects/${id}`, data),
    delete: (id) => apiClient.delete(`/projects/${id}`),
    uploadImage: async (projectId, file, isPrimary = false) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await fetch(
            `${BASE_URL}/projects/${projectId}/images?isPrimary=${isPrimary}`,
            { method: 'POST', headers: getHeaders(), body: formData }
        );
        if (!response.ok) throw new Error('Image upload failed');
        return response.json();
    },
    deleteImage: (projectId, imageId) => apiClient.delete(`/projects/${projectId}/images/${imageId}`),
};
